import api from '../api'

export const getUsers = (params) => api.get('/user', { params })

export const forgotPassword = (params) => api.post('/auth/forgot', params)

export const resetPassword = (params) => api.post('/auth/reset', params)

export const putPersonalInformation = (params) => api.put('/shared/users', params)

export const patchUserPassword = (params) => api.patch('/shared/users/passwords', params)

export const postCompanyUser = ({ isRootRequest, ...params }) => api.post(
  isRootRequest
    ? `/admin/companies/${ params.companyId }/users`
    : '/companies/users',
  params
)

export const putCompanyUser = ({ isRootRequest, ...params }) => api.put(
  isRootRequest
    ? `/admin/companies/${ params.companyId }/users/${ params.id }`
    : `/companies/users/${ params.id }`,
  params
)

export const patchCompanyUser = (params) => api.patch(
  `/admin/companies/${ params.companyId }/users/${ params.id }/active-inactive`
)

export const deleteCompanyUser = ({ isRootRequest, ...params }) => api.delete(
  isRootRequest
    ? `/admin/companies/${ params.companyId }/users/${ params.id }`
    : `/companies/users/${ params.id }`
)

export const resetPasswordCompanyUser = (userId) => api.patch(`/companies/users/password/${ userId }`)

export const postFarmUser = (params) => api.post('/farms/users', params)

export const putFarmUser = (params) => api.put(`/farms/users/${ params.id }`, params)

export const deleteFarmUser = (params) => api.delete(`/farms/users/${ params.id }`)
